import { cn } from '@/utils/app.utils';
import React, { ReactNode } from 'react';

const getSpacingClassName = (spacing: number) => {
  switch (spacing) {
    case 1:
      return 'gap-1';
    case 2:
      return 'gap-2';
    case 3:
      return 'gap-3';
    case 4:
      return 'gap-4';
    case 5:
      return 'gap-5';
    case 6:
      return 'gap-6';
    case 7:
      return 'gap-7';
    case 8:
      return 'gap-8';
    case 9:
      return 'gap-9';
    case 10:
      return 'gap-10';
    default:
      return 'gap-2';
  }
};

type Props = {
  direction?: 'row' | 'column';
  spacing?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10; // Limit to class available in tailwind
  children: ReactNode;
  className?: string;
  keepRowResponsive?: boolean;
};

const Stack = ({
  direction = 'column',
  spacing = 2,
  children,
  className,
  keepRowResponsive = false,
  ...props
}: Props) => {
  const isRow = direction === 'row';
  const spacingClass = getSpacingClassName(spacing);

  return (
    <div
      className={cn(
        'flex',
        isRow ? 'flex-row' : 'flex-col',
        { ['max-md:flex-col']: !keepRowResponsive },
        spacingClass,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default Stack;
